// extracted by mini-css-extract-plugin
export default {"icon":"Contact_icon__cLk-B","form":"Contact_form__iFHW+","input":"Contact_input__grlYy","textarea":"Contact_textarea__1+IP2","submitbtn":"Contact_submitbtn__M4V3I"};